module.exports = __webpack_public_path__ + "static/media/0001.775b7937.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48011/Chassis_RAL/0001.png
// module id = 463
// module chunks = 0